// type dictType = {
//     "coupling": {
//         name: string,
//         formulaImage:string,
//         formData: Array<any>,
//         defaultResultList: Array<any>
//     }
// }

const Dict = {
    "torque-hinge": {
        name: "扭矩铰链",
        formulaImage: '/automatic-calculation/torque-hinge.png',
        formData: [{
            key: 0,
            required: true,
            label: "安装方向",
            name: "Direction",
            type: "Radio",
            options: [
                { label: '径向/垂直安装（左右开合）', value: 'vertical' },
                { label: '横向/水平安装（上下开合）', value: 'horizontal' }
            ],
            initialValue: 'vertical',
            colSpan: true,
        },
        {
            key: 1,
            required: true,
            label: "门的重量",
            name: "Weight",
            desc: "KG"
        }, {
            key: 2,
            required: true,
            label: "门板的宽度",
            name: "Width",
            desc: "mm"
        }],
        defaultResultList: [{
            key: 0,
            label: '扭矩力',
            value: '',
            desc: 'N·m'
        }]
    },
    "synchronous-belt-circumference": {
        name: "同步带周长",
        formulaImage: '/automatic-calculation/synchronous-belt-circumference.png',
        formData: [{
            key: 0,
            required: true,
            type: "Select",
            options: [
                { value: 2.032, label: "MXL" },
                { value: 5.08, label: "XL" },
                { value: 9.525, label: "L" },
                { value: 12.7, label: "H" },
                { value: 2, label: "S2M/2GT" },
                { value: 3, label: "3M/S3M/3GT" },
                { value: 5, label: "5M/S5M/T5/AT5" },
                { value: 8, label: "8M/S8M" },
                { value: 10, label: "T10/AT10" },
                { value: 14, label: "14M/S14M" },
            ],
            label: "齿形",
            name: "Weight",
            desc: "KG"
        }, {
            key: 1,
            required: true,
            label: "主动轮齿数Z1",
            name: "DrivingWheelNum",
            desc: "个"
        }, {
            key: 2,
            required: true,
            label: "被动轮齿数Z2",
            name: "PassivewheelNum",
            desc: "个"
        }, {
            key: 3,
            required: true,
            label: "设计中心距C",
            name: "CenterDistance",
            desc: "mm"
        }],
        defaultResultList: [{
            key: 0,
            label: '扭矩力',
            value: '',
            desc: 'N·m'
        }]
    },
    "motor-torque": {
        name: "电机力矩",
        formulaImage: '/automatic-calculation/motor-torque.png',
        formData: [{
            key: 0,
            required: true,
            label: "电机功率 P",
            name: "MotorPower",
            desc: "kw"
        }, {
            key: 1,
            required: true,
            label: "电机转速 N",
            name: "MotorSpeed",
            desc: "r/min"
        }],
        defaultResultList: [{
            key: 0,
            label: '电机力矩 T',
            value: '',
            desc: 'N·m'
        }]
    },
    "sprocket-chain": {
        name: "链轮链条",
        formulaImage: '/automatic-calculation/sprocket-chain.png',
        formData: [{
            key: 3,
            required: true,
            type: "Select",
            label: "索引号",
            options: [
                { value: '1(05B)', label: '1(05B)' },
                { value: '2(06B)', label: '2(06B)' },
                { value: '3(08A)', label: '3(08A)' },
                { value: '4(08B)', label: '4(08B)' },
                { value: '5(081)', label: '5(081)' },
                { value: '6(083)', label: '6(083)' },
                { value: '7(084)', label: '7(084)' },
                { value: '8(085)', label: '8(085)' },
                { value: '9(10A)', label: '9(10A)' },
                { value: '10(10B)', label: '10(10B)' },
                { value: '11(12A)', label: '11(12A)' },
                { value: '12(12B)', label: '12(12B)' },
                { value: '13(16A)', label: '13(16A)' },
                { value: '14(16B)', label: '14(16B)' },
                { value: '15(20A)', label: '15(20A)' },
                { value: '16(20B)', label: '16(20B)' },
                { value: '17(24A)', label: '17(24A)' },
                { value: '18(24B)', label: '18(24B)' },
                { value: '19(28A)', label: '19(28A)' },
                { value: '20(28B)', label: '20(28B)' },
                { value: '21(32A)', label: '21(32A)' },
                { value: '22(32B)', label: '22(32B)' },
                { value: '23(36A)', label: '23(36A)' },
                { value: '24(40A)', label: '24(40A)' },
                { value: '25(40B)', label: '25(40B)' },
                { value: '26(48A)', label: '26(48A)' },
                { value: '27(48B)', label: '27(48B)' },
                { value: '28(57B)', label: '28(57B)' },
                { value: '29(64B)', label: '29(64B)' },
                { value: '30(72B)', label: '30(72B)' }
            ],
            name: "IndexNum",
            desc: "mm/s"
        }, {
            key: 1,
            required: true,
            label: "主动轮齿数 Z1",
            name: "DrivingGearNum",
            desc: ""
        }],
        defaultResultList: [{
            key: 0,
            label: '节距 p',
            value: '',
            desc: ''
        }, {
            key: 1,
            label: '滚子直径 d1',
            value: '',
            desc: ''
        }, {
            key: 2,
            label: '内链板高度 h2',
            value: '',
            desc: ''
        }, {
            key: 3,
            label: '内链节内宽 b1',
            value: '',
            desc: ''
        }, {
            key: 4,
            label: '分度圆直径 d',
            value: '',
            desc: ''
        }, {
            key: 5,
            label: '齿顶圆最大直径 da max',
            value: '',
            desc: ''
        }, {
            key: 6,
            label: '齿顶圆最小直径 da min',
            value: '',
            desc: ''
        }, {
            key: 7,
            label: '齿顶圆平均直径 da mid',
            value: '',
            desc: ''
        }, {
            key: 8,
            label: '齿根圆直径 dr',
            value: '',
            desc: ''
        }, {
            key: 9,
            label: '齿侧凸缘直径 dg≤',
            value: '',
            desc: ''
        }]
    },
    "cylinder": {
        name: "气缸",
        formulaImage: '/automatic-calculation/cylinder.png',
        formData: [{
            key: 0,
            required: true,
            label: "负载重量 F",
            name: "LoadWeight",
            desc: "kg"
        }, {
            key: 1,
            required: true,
            label: "气缸行程 S",
            name: "CylinderStroke",
            desc: "mm"
        }, {
            key: 2,
            required: true,
            label: "气缸动作时间 T",
            name: "CylinderActionTime",
            desc: "s"
        }, {
            key: 3,
            required: true,
            label: "使用空气压力 P",
            name: "UsingAirPressure",
            desc: "mpa"
        }],
        defaultResultList: [{
            key: 0,
            label: '缸径 D',
            value: '',
            desc: 'mm'
        }]
    },
    "straight-bevel-gear": {
        name: "直齿锥齿轮",
        formulaImage: '/automatic-calculation/straight-bevel-gear.png',
        formData: [{
            key: 0,
            required: true,
            label: "大端模数m",
            name: "OuterModule ",
            desc: ""
        }, {
            key: 1,
            required: true,
            label: "齿数z1",
            name: "TeethNumZ1",
            desc: ""
        }, {
            key: 2,
            required: true,
            label: "齿数z2",
            name: "TeethNumZ2",
            desc: ""
        }],
        defaultResultList: [{
            key: 0,
            label: '分锥角-1',
            value: '',
            desc: ''
        }, {
            key: 1,
            label: '分锥角-2',
            value: '',
            desc: ''
        }, {
            key: 2,
            label: '分度圆直径-d1',
            value: '',
            desc: ''
        }, {
            key: 3,
            label: '分度圆直径-d2',
            value: '',
            desc: ''
        }, {
            key: 4,
            label: '齿顶高-ha',
            value: '',
            desc: ''
        }, {
            key: 5,
            label: '齿根高-hf',
            value: '',
            desc: ''
        }, {
            key: 6,
            label: '锥距-R1',
            value: '',
            desc: ''
        }, {
            key: 7,
            label: '锥距-R2',
            value: '',
            desc: ''
        }, {
            key: 8,
            label: '齿顶角-1',
            value: '',
            desc: ''
        }, {
            key: 9,
            label: '齿顶角-2',
            value: '',
            desc: ''
        }, {
            key: 10,
            label: '齿根角-1',
            value: '',
            desc: ''
        }, {
            key: 11,
            label: '齿根角-2',
            value: '',
            desc: ''
        }, {
            key: 12,
            label: '顶锥角-1',
            value: '',
            desc: ''
        }, {
            key: 13,
            label: '顶锥角-2',
            value: '',
            desc: ''
        }, {
            key: 14,
            label: '根锥角-1',
            value: '',
            desc: ''
        }, {
            key: 15,
            label: '根锥角-2',
            value: '',
            desc: ''
        }, {
            key: 16,
            label: '锥顶到大端顶圆的距离-H1',
            value: '',
            desc: ''
        }, {
            key: 17,
            label: '锥顶到大端顶圆的距离-H2',
            value: '',
            desc: ''
        }]
    },
    "circular-belt-length": {
        name: "圆皮带长度",
        formulaImage: '/automatic-calculation/circular-belt-length.png',
        formData: [{
            key: 0,
            required: true,
            label: "小皮带轮直径 dm",
            name: "SmallPulleyDiameter",
            desc: "mm"
        }, {
            key: 1,
            required: true,
            label: "大皮带轮直径 df",
            name: "LargePulleyDiameter",
            desc: "mm"
        }, {
            key: 2,
            required: true,
            label: "皮带轮中心距 Lfm",
            name: "BeltPulleyCenterDistance",
            desc: "mm"
        }],
        defaultResultList: [{
            key: 0,
            label: '皮带长度 Lb',
            value: '',
            desc: 'mm'
        }]
    },
    "chain-length": {
        name: "拖链长度",
        formulaImage: '/automatic-calculation/chain-length.png',
        formData: [{
            key: 0,
            required: true,
            label: "行程 S",
            name: "Stroke",
            desc: "mm"
        }, {
            key: 1,
            required: true,
            label: "弯曲半径 R",
            name: "BendingRadius",
            desc: "mm"
        }, {
            key: 2,
            required: true,
            label: "节距 P",
            name: "Pitch",
            desc: "mm"
        }],
        defaultResultList: [{
            key: 0,
            label: '拖链长度 L',
            value: '',
            desc: 'mm'
        }, {
            key: 1,
            label: '拖链节数 N',
            value: '',
            desc: '节'
        }]
    },
    "coupling": {
        name: "联轴器",
        formulaImage: '/automatic-calculation/power-machine-coefficient.png',
        formData: [{
            key: 0,
            required: true,
            label: "电机功率 P",
            name: "MotorPower",
            desc: "W"
        }, {
            key: 1,
            required: true,
            label: "电机转速 N",
            name: "MotorSpeed",
            desc: "r/min"
        }, {
            key: 2,
            required: true,
            label: "减速比",
            name: "ReductionRatio",
            desc: "例如：减速比1:25，请输入25。"
        }, {
            key: 3,
            required: true,
            type: "Select",
            label: "动力机系数Kw",
            options: [
                { value: 1, label: 1 },
                { value: 1.2, label: 1.2 },
                { value: 1.4, label: 1.4 },
                { value: 1.6, label: 1.6 }
            ],
            name: "PowerMachineCoefficient",
            desc: "请查左边对应表"
        }, {
            key: 4,
            required: true,
            type: "Select",
            options: [
                { value: 1, label: 1 },
                { value: 1.75, label: 1.75 },
                { value: 2.5, label: 2.5 },
                { value: 4, label: 4 }
            ],
            label: "工况系数K",
            name: "WorkCoefficient",
            desc: "请查左边对应表"
        }, {
            key: 5,
            required: true,
            type: "Select",
            options: [
                { value: 1, label: 1 },
                { value: 1.4, label: 1.4 },
                { value: 1.8, label: 1.8 },
                { value: 2.2, label: 2.2 }
            ],
            label: "启动系数Kz",
            name: "StartCoefficient",
            desc: "请查左边对应表"
        }, {
            key: 6,
            required: true,
            type: "Select",
            options: [
                { value: 1, label: 1 },
                { value: 1.2, label: 1.2 },
                { value: 1.3, label: 1.3 },
                { value: 1.4, label: 1.4 },
                { value: 1.55, label: 1.55 },
                { value: 1.8, label: 1.8 },
                { value: 2.2, label: 2.2 },
                { value: 3, label: 3 }
            ],
            label: "温度系数Kt",
            name: "TemperatureCoefficient",
            desc: "请查左边对应表"
        }],
        defaultResultList: [{
            key: 1,
            label: '电机力矩T1',
            value: '',
            desc: 'N·m'
        }, {
            key: 2,
            label: '联轴器计算扭矩T',
            value: '',
            desc: 'N·m'
        }]
    },
    "synchronous-pulley": {
        name: "同步带轮",
        formulaImage: '/automatic-calculation/synchronous-pulley.png',
        formData: [{
            key: 0,
            required: true,
            label: "传动动力 Pt",
            name: "TransmissionPower",
            desc: "KW"
        }, {
            key: 1,
            required: true,
            label: "小带轮转速 r",
            name: "SmallPulleySpeed",
            desc: "r/min"
        }, {
            key: 2,
            required: true,
            label: "大带轮转速 R",
            name: "LargePulleySpeed",
            desc: "r/min"
        }, {
            key: 3,
            required: true,
            label: "轮轴间距 d",
            name: "WheelAxleSpacing",
            desc: "mm"
        }, {
            key: 6,
            required: true,
            type: "Select",
            options: [
                { value: 1, label: '展览机械、放映机、计量设备、医疗设备' },
                { value: 2, label: '吸尘器、缝纫机、办公设备、木工车床、带锯' },
                { value: 3, label: '轻载型皮带输送机、包装机械、筛子' },
                { value: 4, label: '液体搅拌机、钻床、车床、螺纹加工机、圆盘锯床、刨床、洗衣机、造纸机械、印刷机械' },
                { value: 5, label: '搅拌机（水泥、粘性体）、皮带输送机（矿石、煤、沙石）、磨床、牛头刨床、镗床、铣床、缩机' },
                { value: 6, label: '输送机（板式、盘式、链斗式）、抽气泵、风扇、鼓风机、发电机、励磁器、起重机、升降机、橡胶加工机械' },
                { value: 7, label: '离心分离机、输送机（刮板式、螺旋式）、锤击式粉碎机、打浆机' }
            ],
            label: "机械种类",
            name: "MechanicalType",
            desc: ""
        }, {
            key: 7,
            required: true,
            type: "Select",
            options: [
                { value: 1, label: '最大输出功率为额定值的300%以下直流电机（标准电机、同步电机）直流电机（并绕）、2缸以上发动机' },
                { value: 2, label: '最大输出功率为额定值的300%以上特殊电机（高扭矩）、通过旋转轴或离合器运行直流电机（串绕）、单杠发动机' }
            ],
            label: "传动动力",
            name: "TransmissionPower",
            desc: ""
        }, {
            key: 8,
            required: true,
            type: "Select",
            options: [
                { value: 1, label: '间歇使用1天3~5小时' },
                { value: 2, label: '正常使用1天8~12小时' },
                { value: 3, label: '连续使用1天16~24小时' }
            ],
            label: "运动时间",
            name: "ExerciseTime",
            desc: ""
        }, {
            key: 9,
            required: true,
            type: "Select",
            options: [
                { value: 1, label: '松弛内侧' },
                { value: 2, label: '松弛外侧' },
                { value: 3, label: '张紧内侧' },
                { value: 4, label: '张紧外侧' },
            ],
            label: "惰轮位置",
            name: "IdlerPosition",
            desc: ""
        }],
        defaultResultList: [{
            key: 1,
            label: '负载补偿系数 Ko',
            name: 'Ko',
            value: '',
            desc: ''
        }, {
            key: 2,
            label: '旋转比补偿系数 Kr',
            name: 'Kr',
            value: '',
            desc: ''
        }, {
            key: 3,
            label: '惰轮补偿系数 Ki',
            name: 'Ki',
            value: '',
            desc: ''
        }, {
            key: 4,
            label: '过载修正系数 Ks',
            name: 'Ks',
            value: '',
            desc: ''
        }, {
            key: 5,
            label: '设计动力 Pd',
            name: 'Pd',
            value: '',
            desc: 'KW'
        }, {
            key: 6,
            label: '传动比 i',
            name: 'i',
            value: '',
            desc: '%'
        }]
    },
    "vacuum-suction-cup": {
        name: "真空吸盘",
        formulaImage: '/automatic-calculation/vacuum-suction-cup.png',
        formData: [{
            key: 0,
            required: true,
            label: "吸吊物重量 W",
            name: "W",
            desc: "kg"
        }, {
            key: 1,
            required: true,
            label: "安全系数 f",
            name: "f",
            desc: "水平（>=4）,竖直（>=8）"
        }, {
            key: 2,
            required: true,
            label: "吸盘内的真空压力（真空度）p",
            name: "p",
            desc: "MPa"
        }, {
            key: 3,
            required: true,
            label: "吸盘的数量 n",
            name: "n",
            desc: "个"
        }],
        defaultResultList: [{
            key: 1,
            label: '吸盘直径 D (计算值)',
            name: 'D',
            value: '',
            desc: 'mm'
        }]
    }
}

export default Dict